module.exports = "https://www.gc-pro.gnp.com.mx/13102c5c384cb067078849bcb4d8679a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dbk_reg_serie.png
// module id = 8099
// module chunks = 0